import { useState } from "react";
import { Dialog } from "@headlessui/react";
import { XMarkIcon, InformationCircleIcon } from "@heroicons/react/24/outline";
import PromoPayModal from "./PromoPayModal";
import PromotionalProfileForm from "./PromotionalProfileForm";

export default function PromotionalProfileModal({ isOpen, onClose, userId }) {
  const [step, setStep] = useState("info");
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    tags: "",
    profilePhoto: null,
    externalLinks: "",
  });

  const handleAgree = () => setStep("payment");
  const handlePaymentSuccess = () => setStep("form");

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: files ? files[0] : value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  // Función que cierra todo el modal y resetea estado
  const closeAndReset = () => {
    setStep("info");
    setFormData({
      name: "",
      description: "",
      tags: "",
      profilePhoto: null,
      externalLinks: "",
    });
    onClose();
  };

  return (
    <Dialog open={isOpen} onClose={closeAndReset} className="fixed z-50 inset-0 overflow-y-auto">
      <div className="flex items-center justify-center min-h-screen px-4">
        <div className="fixed inset-0 bg-black opacity-30" aria-hidden="true" />
        <div className="relative bg-white rounded-lg shadow-lg w-full max-w-md p-6 z-10">
          {/* Botón para cerrar el modal general */}
          <button
            onClick={closeAndReset}
            className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
            aria-label="Cerrar modal"
          >
            <XMarkIcon className="h-5 w-5" />
          </button>

          {step === "info" && (
            <>
              <Dialog.Title className="flex items-center text-lg font-semibold mb-4">
                Crear Perfil Promocional
                <InformationCircleIcon
                  className="h-6 w-6 text-blue-500 ml-2 cursor-pointer"
                  title="Información importante"
                />
              </Dialog.Title>
              <p className="text-gray-700 mb-6">
                Para crear un perfil profesional debes adquirir una membresía activa...
              </p>
              <button
                onClick={handleAgree}
                className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition"
              >
                De acuerdo, quiero crear mi perfil promocional
              </button>
            </>
          )}

          {step === "form" && (
            <PromotionalProfileForm
              formData={formData}
              onChange={handleChange}
              onSubmit={handleSubmit}
              onClose={closeAndReset}  // <-- Aquí pasamos la función para cerrar todo
            />
          )}
        </div>
      </div>

      {step === "payment" && (
        <PromoPayModal
          userId={userId}
          onClose={closeAndReset}
          onSuccess={handlePaymentSuccess}
        />
      )}
    </Dialog>
  );
}
